import useSWR from "swr";
import { fetcher, overviewDefaultState } from "../components/Overview/Overview";
import { useDebounce } from "../utils/debounce";
import axios from "axios";
import { appendSearchParams } from "../utils/urls";

// Function which fetches results from the server using SWR)
export function getStudents(stateToDebounce) {
    const state = useDebounce(stateToDebounce, 300);

    const params = new URLSearchParams({
        offset: state.offset,
        is_active: true,
        limit: state.size,
        ordering: (state?.ordering?.direction || "") + (state?.ordering?.columnIdentifier || "name")
    });

    let filtering = "";

    if (state?.filter) {
        appendSearchParams(params, state.filter);

        // filtering =
        //     "&" +
        //     Object.entries(state.filter)
        //         .filter((o) => o[1] !== "" && o[1] !== null && o[1] !== undefined && o[1]?.length !== 0)
        //         .map((obj, idx) => {
        //             const [key, value] = obj;
        //             return `${key}=${Array.isArray(value) ? value.join("&" + key + "=") : value}`;
        //         })
        //         .join("&");
    }

    const fields = state?.columns?.length > 0 ? state?.columns?.map((o) => o.columnIdentifier).join(",") : "";
    if (fields) {
        appendSearchParams(params, { fields });
    }

    // let ordering = (state?.ordering?.direction || "") + (state?.ordering?.columnIdentifier || "name");

    // if (state?.identifier) {
    //     console.info("getStudents(): OLD", `/v1/students/?offset=${state.offset}${fields}&is_active=true&limit=${state.size}&ordering=${ordering}${filtering}`);
    //     console.info("getStudents(): NEW", `/v1/students/?${params.toString()}`);
    // }

    // Use SWR accepts both an url or a function as its first param.
    // When passing an url it uses the URL as a cache key, fetches the result, and stores it for the default amount of time
    // When passing a function, the function can evaluate vars before returning the URL. This is usefull for 2 checking
    // if required params or dependencies are set. When a falsy result is returned it is handled as a non-call
    // Please note: as SWR is a Hook, it should always return the same result (even if something is wrong!)
    // Therefore you can not just return false to the one calling getCourses
    return useSWR(() => (state?.identifier ? `/v1/students/?${params.toString()}` : false), fetcher);
}

export function getCourseStudents(stateToDebounce, pagination = true) {
    const state = useDebounce(stateToDebounce, 300);

    // let filtering = "";

    // if (state?.filter) {
    //     filtering =
    //         "&" +
    //         Object.entries(state.filter)
    //             .filter((o) => o[1] !== "" && o[1] !== null && o[1] !== undefined && o[1]?.length !== 0)
    //             .map((obj, idx) => {
    //                 const [key, value] = obj;
    //                 return `${key}=${Array.isArray(value) ? value.join("&" + key + "=") : value}`;
    //             })
    //             .join("&");
    // }

    const fields =
        state?.columns?.length > 0
            ? state?.columns?.map((o) => o.columnIdentifier).join(",") + state.additionalFields.length > 0
                ? "," + state?.additionalFields.join(",")
                : ""
            : "";

    // let ordering = (state?.ordering?.direction || "") + (state?.ordering?.columnIdentifier || "name");

    const params = new URLSearchParams({
        offset: state.offset,
        is_active: true,
        limit: state.size,
        ordering: (state?.ordering?.direction || "") + (state?.ordering?.columnIdentifier || "name")
    });
    if (state?.filter) {
        appendSearchParams(params, state.filter);
    }
    if (fields) {
        appendSearchParams(params, { fields });
    }
    if (state?.filter?.search) {
        const transformedSearch = state?.filter?.search?.replace(/-/g, "");
        params.append("search", transformedSearch);
    }

    // if (state?.identifier) {
    //     // console.info({state, fields});
    //     // console.info("getCourseStudents(): OLD", `/v1/courses/${state.identKey?.courseID}/students/?getCourseStudents&is_active=true${fields}${filtering}&pagination=${pagination}&offset=${
    //     //     state.offset
    //     // }&ordering=${ordering}&limit=${state.size || overviewDefaultState.pagination.cursorPaginator.size}`);
    //     console.info("getCourseStudents(): NEW", `/v1/courses/${state.identKey?.courseID}/students/?getCourseStudentsV2&${params.toString()}`);
    // }

    // Use SWR accepts both an url or a function as its first param.
    // When passing an url it uses the URL as a cache key, fetches the result, and stores it for the default amount of time
    // When passing a function, the function can evaluate vars before returning the URL. This is useful for 2 checking
    // if required params or dependencies are set. When a falsy result is returned it is handled as a non-call
    // Please note: as SWR is a Hook, it should always return the same result (even if something is wrong!)
    // Therefore, you can not just return false to the one calling getCourses

    const url = state?.filter && state?.identKey?.courseID ? `/v1/courses/${state.identKey?.courseID}/students/?${params.toString()}` : null;

    const result = useSWR(url, fetcher, {
        revalidateOnFocus: false,
        revalidateIfStale: false,
        revalidateOnReconnect: false,
        dedupingInterval: 2000,
        keepPreviousData: true
    });

    if (result?.data?.results) {
        result.data.results.sort((a, b) => {
            if (a.last_name < b.last_name) return -1;
            if (a.last_name > b.last_name) return 1;
            return 0;
        });
    }

    return result;
}

export async function remoteDeleteStudent(courseUUID = false, studentUUID = false) {
    let errors = [];
    let result = null;

    if (!!courseUUID === false) {
        errors.push("missing course UUID");
    }
    if (!!studentUUID === false) {
        errors.push("missing student UUID");
    }

    if (errors.length > 0) {
        return {
            result,
            errors
        };
    }

    result = await axios
        .delete(`/v1/courses/${courseUUID}/students/${studentUUID}/`)
        .then((result) => result)
        .catch((error) => {
            if (error.response) {
                for (const [field, error] of Object.entries(error.response.data)) {
                    errors.push({ field: field, error: error[0] });
                }
            }
        });

    return {
        result,
        errors
    };
}

export async function remoteCancelStudent(courseUUID = false, studentUUID = false) {
    let errors = [];
    let result = null;

    if (!!courseUUID === false) {
        errors.push("missing course UUID");
    }
    if (!!studentUUID === false) {
        errors.push("missing student UUID");
    }

    if (errors.length > 0) {
        return {
            result,
            errors
        };
    }

    result = await axios
        .patch(`/v1/courses/${courseUUID}/students/${studentUUID}/`, {
            cancelled: true
        })
        .then((result) => result)
        .catch((error) => {
            if (error.response) {
                for (const [field, error] of Object.entries(error.response.data)) {
                    errors.push({ field: field, error: error[0] });
                }
            }
        });

    return {
        result,
        errors
    };
}
